import { IErrorData } from 'error-handler/functions/sendError';
import config from 'error-handler/config';
import Telegram from 'error-handler/helper/Telegram';

const telegram = async (errorData: IErrorData, logs: any[], message: string) => {
  const { funcName, metaInfo } = errorData;

  const messageWishLogs = `Page: <i>${location.href}</i> ${funcName ? `Function: ${funcName}()` : ''}
${
  metaInfo
    ? `\n ${Object.entries(metaInfo)
        .map(([key, value]: string[]) => `${key}: <b>${value}</b>`)
        .join('\n')}`
    : ``
}

Logs:
${logs.map((item: any) => `${item.tag}\t\t.${item.class}\t\t${item.content.substr(0, 140)}`).join('\n')}

${message}`;

  if (config.host !== 'loc') await new Telegram('error').send(messageWishLogs);
};

export default telegram;
